var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNetwrix(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 220 45.5",
    style: {
      enableBackground: "new 0 0 220 45.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M171.4,0v6.9h9V0H171.4z M171.4,8.7v35.9h9V8.7H171.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M72.6,0.6v29.2c0,2.4,0.3,4.6,1,6.5c0.7,1.9,1.7,3.5,3,4.8c1.3,1.3,2.9,2.3,4.9,2.9s4.2,0.8,6.8,0.5v-8.2 c-2.3,0.1-4-0.3-5.1-1.3c-1.1-1-1.7-2.7-1.7-5.2V17.5h6.3v-8h-6.3V0.6H72.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M15.8,8.7c-2.4,0-4.6,0.4-6.5,1.2c-1.9,0.8-3.6,1.9-4.9,3.3c-1.4,1.4-2.4,3.1-3.2,5C0.4,20,0,22.1,0,24.3v20.3 h9V24.1c0-2,0.6-3.6,1.9-4.8c1.3-1.2,2.9-1.8,4.9-1.8c1.5,0,2.7,0.3,3.5,0.8c0.9,0.5,1.5,1.1,2,1.8c0.5,0.7,0.8,1.5,0.9,2.2 c0.1,0.7,0.2,1.3,0.2,1.8v20.5h9V24.3c0-2.3-0.4-4.4-1.1-6.3c-0.7-1.9-1.7-3.5-3-4.9c-1.3-1.4-3-2.5-4.9-3.3 C20.4,9.1,18.2,8.7,15.8,8.7L15.8,8.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M52.4,8.6c-2.5,0-4.8,0.5-7,1.5c-2.2,0.9-4.1,2.2-5.7,3.9c-1.6,1.6-2.9,3.6-3.9,5.9c-0.9,2.2-1.4,4.6-1.4,7.1 s0.5,4.9,1.4,7.1c1,2.2,2.2,4.2,3.9,5.9c1.6,1.6,3.5,2.9,5.7,3.9s4.5,1.4,7,1.4c4.4,0,8.1-1.1,11-3.3c3-2.2,5-5.1,6-8.7h-9.6 c-0.8,1.4-1.8,2.5-3.2,3.2c-1.4,0.6-2.8,1-4.2,1c-1.5,0-3-0.3-4.2-1c-1.3-0.7-2.3-1.6-3.2-2.8l24.8-10.4c-0.4-2.4-1.2-4.4-2.2-6.3 c-1.1-1.8-2.3-3.3-3.9-4.6c-1.5-1.3-3.2-2.2-5.1-2.9C56.5,9,54.5,8.6,52.4,8.6L52.4,8.6z M52.3,16.6c1.5,0,2.8,0.3,4,0.8 c1.2,0.5,2.2,1.3,3,2.3l-16.5,7c0-1.5,0.3-2.9,0.8-4.1c0.5-1.2,1.2-2.3,2-3.1c0.9-0.9,1.8-1.6,3-2.1C49.8,16.8,51,16.6,52.3,16.6 L52.3,16.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M164.5,8.7c-1.7,0-3.2,0.2-4.7,0.6c-2.3,0.6-4.2,1.6-5.8,3.1c-1.6,1.4-2.8,3.1-3.7,5.2c-0.8,2-1.2,4.3-1.2,6.8 v20.3h9V24.3c0-2.5,0.9-4.4,2.6-5.7c1.8-1.4,4.1-1.8,6.9-1.3V8.9C166.6,8.7,165.5,8.7,164.5,8.7L164.5,8.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M183.7,9.3l12.2,17.1l-12.7,18.2h10.9l7.2-10.9l7.2,10.9H220L206.9,26l12-16.7h-11l-6.6,9.7l-6.2-9.7H183.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M91.7,9.6v20.2c0,2.3,0.3,4.4,1,6.4c0.7,1.9,1.8,3.6,3.1,5c1.4,1.4,3,2.4,4.9,3.2s4.1,1.2,6.5,1.2 c2.3,0,4.4-0.4,6.3-1.3c1.9-0.9,3.5-2.1,4.8-3.7c1.3,1.5,2.9,2.8,4.8,3.7c1.9,0.9,4.1,1.3,6.5,1.3c2.4,0,4.5-0.4,6.5-1.2 c1.9-0.8,3.6-1.9,5-3.3c1.4-1.4,2.5-3.1,3.2-5c0.8-2,1.2-4,1.2-6.2V9.6h-9V30c0,2-0.6,3.6-1.9,4.8c-1.3,1.2-2.9,1.8-4.9,1.8 c-1.5,0-2.7-0.2-3.6-0.7c-0.9-0.5-1.5-1.1-2-1.8c-0.5-0.7-0.8-1.5-0.9-2.2c-0.1-0.8-0.2-1.4-0.2-1.9V9.6h-9V30c0,2-0.7,3.6-1.9,4.8 c-1.2,1.2-2.8,1.8-4.9,1.8c-1.5,0-2.6-0.2-3.5-0.7c-0.9-0.5-1.5-1.1-2-1.8c-0.5-0.7-0.8-1.5-0.9-2.2c-0.1-0.8-0.2-1.4-0.2-1.9V9.6 H91.7z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetwrix);
export default __webpack_public_path__ + "static/media/Netwrix.21ca8b00e8cf5d389b0d4ec8d8c78680.svg";
export { ForwardRef as ReactComponent };